import {
  useEffect,
  useContext,
  useState,
  useRef,
} from "react";

import Plyr from "plyr";

import "../assets/styles/plyr.css";

import { Context } from "../store";
import {
  setPlayer,
  toggleContinue,
  toggleQuestions,
} from "../store/reducer";

import Controls from "./Controls/Controls";
import classNames from "classnames";

export const LANGUAGES = {
  en: "English",
  de: "Deutsch",
  se: "svenska",
  fr: "Français",
  frca: "Français Canadien",
  it: "Italiano",
  nl: "Nederlands",
  ptbr: "Português",
  spmx: "Español",
  zh: "简体中文",
};

const VideoPlayer = () => {
  const [hasStarted, setHasStarted] = useState(false);
  const playerRef = useRef(null);
  const [{ player, currentItem }, dispatch] =
    useContext(Context);

  const onVideoEnd = () => {
    if (currentItem && currentItem.questions) {
      dispatch(toggleQuestions());
    } else {
      dispatch(toggleContinue());
    }
  };

  useEffect(() => {
    if (!player && playerRef) {
      dispatch(
        setPlayer(
          new Plyr("#player", {
            captions: {
              active: true,
            },
          })
        )
      );
    }
  }, [player, dispatch]);

  return (
    <>
      {!hasStarted && (
        <div
          className={
            "flex justify-center items-center h-screen w-screen"
          }
        >
          <img
            src={process.env.PUBLIC_URL + "poster.jpeg"}
            alt="poster"
            className={"block "}
            onClick={() => {
              player.play();
            }}
          />
        </div>
      )}
      <Controls />
      <video
        id="player"
        ref={playerRef}
        className="h-screen w-screen"
        style={{ display: !hasStarted ? "none" : "flex" }}
        controls
        playsInline
        autoPlay
        onPlay={() => setHasStarted(true)}
        onEnded={onVideoEnd}
        src={`${process.env.PUBLIC_URL}/clips/${currentItem?.section}.mp4`}
      >
        {Object.entries(LANGUAGES).map(([key, value]) => (
          <track
            key={key}
            kind="subtitles"
            label={value}
            src={`${process.env.PUBLIC_URL}/srt/${key}/${currentItem?.section}.vtt`}
            srcLang={key}
          />
        ))}
      </video>
    </>
  );
};

export default VideoPlayer;
